import React from 'react';
import { FilterDropdown } from './FilterDropdown';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';

interface StatusFilterDropdownProps {
  selectedStatuses: string[];
  onStatusesChange: (statuses: string[]) => void;
  onApplyFilter: () => void;
  onClearFilter: () => void;
  isFilterApplied: boolean;
}

export const StatusFilterDropdown: React.FC<StatusFilterDropdownProps> = ({
  selectedStatuses,
  onStatusesChange,
  onApplyFilter,
  onClearFilter,
  isFilterApplied,
}) => {
  const { t } = dynamicTranslations();

  const availableStatuses = [
    t('history.documents.filters.available'),
    t('history.documents.filters.processing'),
    t('history.documents.filters.expired'),
  ];

  return (
    <FilterDropdown
      label={t('history.documents.filters.status')}
      selectedItems={selectedStatuses}
      availableItems={availableStatuses}
      onItemsChange={onStatusesChange}
      onApplyFilter={onApplyFilter}
      onClearFilter={onClearFilter}
      isFilterApplied={isFilterApplied}
    />
  );
};
